/*
  Bancroft & Lane: keep the product gallery and the color selection in step.

  1. Changing size keeps the shopper on the photo they are viewing.
  2. Choosing a color moves the gallery to that color's image, unless the photo on screen
     already shows that color.
  3. Moving the gallery to a photo of another color selects that color and keeps the size.

  Each photo's color comes from the [data-bl-gallery-colors] JSON in snippets/product-images.liquid.
  Loaded right after theme.js (layout/theme.liquid). Both hooks are looked up on the prototype
  at call time, so they also cover the product sections theme.js built before this file ran.
*/
(function () {
  if (!window.theme || !theme.Product) {
    throw new Error('bl-gallery-position: load this right after theme.js');
  }

  var proto = theme.Product.prototype;
  var updateVariantImage = proto.updateVariantImage;
  var prepMediaOnSlide = proto.prepMediaOnSlide;

  function galleryColors(product) {
    var el = product.container.querySelector('[data-bl-gallery-colors]');
    if (!el) throw new Error('bl-gallery-position: [data-bl-gallery-colors] is missing from this product');
    return JSON.parse(el.textContent);
  }

  function shownSlide(product) {
    return product.cache.mainSlider.querySelector(
      '.product-main-slide[data-index="' + product.settings.currentSlideIndex + '"]'
    );
  }

  // Variant change: move the gallery only when the photo on screen shows a different color.
  proto.updateVariantImage = function (evt) {
    var colors = galleryColors(this);
    if (!colors.option) return;
    var variantColor = evt.detail.variant.options[colors.position - 1];
    var slide = shownSlide(this);
    if (slide && colors.media[slide.dataset.mediaId] === variantColor) return;
    updateVariantImage.call(this, evt);
  };

  // Gallery change: select the color the new photo shows; the picker keeps the size.
  proto.prepMediaOnSlide = function (slide) {
    prepMediaOnSlide.call(this, slide);
    var colors = galleryColors(this);
    if (!colors.option) return;
    var color = colors.media[slide.dataset.mediaId];
    var picker = this.container.querySelector(this.selectors.picker);
    if (!color || !picker) return;
    var input = Array.prototype.find.call(picker.querySelectorAll('input[type="radio"]'), function (el) {
      return el.name.endsWith('-' + colors.option) && el.value === color;
    });
    if (input && !input.checked) input.click();
  };
})();
